/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BrokerConsultantInformationViewModel } from './BrokerConsultantInformationViewModel';
import {
    BrokerConsultantInformationViewModelFromJSON,
    BrokerConsultantInformationViewModelFromJSONTyped,
    BrokerConsultantInformationViewModelToJSON,
} from './BrokerConsultantInformationViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfBrokerConsultantInformationViewModel
 */
export interface ResultOfBrokerConsultantInformationViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {BrokerConsultantInformationViewModel}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    data?: BrokerConsultantInformationViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfBrokerConsultantInformationViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfBrokerConsultantInformationViewModel interface.
 */
export function instanceOfResultOfBrokerConsultantInformationViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfBrokerConsultantInformationViewModelFromJSON(json: any): ResultOfBrokerConsultantInformationViewModel {
    return ResultOfBrokerConsultantInformationViewModelFromJSONTyped(json, false);
}

export function ResultOfBrokerConsultantInformationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfBrokerConsultantInformationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : BrokerConsultantInformationViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfBrokerConsultantInformationViewModelToJSON(value?: ResultOfBrokerConsultantInformationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': BrokerConsultantInformationViewModelToJSON(value.data),
        'Count': value.count,
    };
}

